import axios from 'axios';
import Config from '../../cankado-config';
import { apiHeaders } from '../../kado/utils/';
import events from '../event-names';

export function ToggleSecondarySB() {
    return {
        type: events.TOGGLE_SECONDARY_SIDEBAR,
    };
}
export function ToggleTertiarySB() {
    return {
        type: events.TOGGLE_TERTIARY_SIDEBAR,
    };
}
export function ToggleFavDrugList() {
    return {
        type: events.TOGGLE_FAVDRUGLIST,
    };
}

export function ToggleAssList() {
    return {
        type: events.TOGGLE_ASSLIST,
    };
}

export function ClearNavigateTo() {
    return {
        type: events.CLEAR_NAVIGATE_TO,
    };
}

export function SetNavigateTo(url) {
    return {
        type: events.SET_NAVIGATE_TO,
        payload: url,
    };
}

export function SetVerifyModalWindow(window) {
    return {
        type: events.SET_VERIFY_MODAL_WINDOW,
        payload: {window: window},
    };
}

export function AcceptTems(payload) {
    return (dispatch) => {
        dispatch({
            type: events.ACCEPT_TERMS,
            meta: payload,
            payload: axios.post([Config.apiRoot, '/terms-condition/'].join(''), { ...payload }, { ...apiHeaders() }),
        });
    };
}
